import './ContentBuilderTemplate.scss';
import './ContentBuilderTemplate41.scss';

import React, { useEffect, useRef } from 'react';
import { usePropsHandler } from '../../EventInterceptor/usePropsHandler';
import { cnContentBuilderTemplate } from './index';
import { Grid, GridItem } from '@dataartdev/uikit/Grid';
import { Typography } from '@dataartdev/uikit/Typography';
import { TwoColTextCard } from '../../TwoColTextCard/TwoColTextCard';
import { Slider, SliderItem } from '@dataartdev/uikit/Slider';
import { Pagination } from '@dataartdev/uikit/Pagination';
import { cn } from '@bem-react/classname';
import { IRoot41 } from './models/CTI_41.props';
import { Swiper } from 'swiper';

const cnTwoColumnCaseSlider = cn('TwoColumnCaseSlider');

const sliderOptions = {
  watchOverflow: false,
  navigation: false,
  spaceBetween: 16,
  slidesPerView: 1,
};

interface SwiperRef {
  swiper: Swiper;
}

export const ContentBuilderTemplate: React.FC<IRoot41> = props => {
  const { type, title, slider, contentId } = usePropsHandler(
    cnContentBuilderTemplate(),
    props
  );

  const [currentPage, setCurrentPage] = React.useState<number>(1);
  const sliderRef = useRef<SwiperRef>(null);

  const typeNumber = type.toString();
  const totalPages = slider?.length || 1;

  useEffect(() => {
    if (sliderRef && sliderRef.current && sliderRef.current.swiper) {
      const swiper = sliderRef.current.swiper;
      swiper.slideTo(currentPage - 1);
    }
  }, [sliderRef, currentPage]);

  useEffect(() => {
    if (sliderRef && sliderRef.current && sliderRef.current.swiper) {
      const swiper = sliderRef.current.swiper;
      swiper.on('slideChange', function() {
        setCurrentPage(swiper.activeIndex + 1);
      });
    }
  }, [sliderRef]);

  const hotKeys = {
    prevPage: {
      label: 'prev',
      values: ['Shift', 'ArrowLeft'],
    },
    nextPage: {
      label: 'next',
      values: ['Shift', 'ArrowRight'],
    },
  };

  const handleChange = (pageNumber: number): void => {
    setCurrentPage(pageNumber);
  };

  return (
    <div
      className={cnContentBuilderTemplate({ type: typeNumber })}
      id={contentId}
    >
      <Grid
        breakpoints={{ desktop: { cols: 12 } }}
        className={cnTwoColumnCaseSlider()}
      >
        {title && (
          <GridItem
            breakpoints={{
              desktop: { col: 8 },
              tablet: { col: 10 },
              mobile: { col: 12 },
            }}
          >
            <Typography.Title size="lg">{title}</Typography.Title>
          </GridItem>
        )}
        {slider && slider?.length > 0 && (
          <GridItem
            breakpoints={{
              desktop: { col: 12 },
              tablet: { col: 12 },
              mobile: { col: 12 },
            }}
          >
            <Slider
              ref={sliderRef}
              {...sliderOptions}
              className={cnTwoColumnCaseSlider('Carousel')}
            >
              {slider.map(slide => (
                <SliderItem key={slide.id}>
                  <TwoColTextCard {...slide} />
                </SliderItem>
              ))}
            </Slider>
            <div className={cnTwoColumnCaseSlider('Pagination')}>
              <Pagination
                currentPage={currentPage}
                onChange={handleChange}
                totalPages={totalPages}
                hotkeys={hotKeys}
              />
            </div>
          </GridItem>
        )}
      </Grid>
    </div>
  );
};

export default ContentBuilderTemplate;
